import React from 'react';
export function SkeletonRecommendLineChart() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative w-full h-[600px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute inset-0 grid grid-cols-12 grid-rows-6"
    }, Array.from({
        length: 72
    }).map((_, i) => /*#__PURE__*/ React.createElement("div", {
        key: i,
        className: "border-b border-r border-slate-100"
    }))), /*#__PURE__*/ React.createElement("svg", {
        className: "absolute inset-0 w-full h-full",
        viewBox: "0 0 1000 400",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: " M 0 180 L 100 160 L 200 190 L 300 150 L 400 170 L 500 140 L 600 160 L 700 130 L 800 150 L 900 140 L 1000 160 ",
        fill: "none",
        stroke: "#93c5fd",
        strokeWidth: "3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: " M 0 260 L 100 240 L 200 250 L 300 230 L 400 260 L 500 240 L 600 250 L 700 235 L 800 245 L 900 240 L 1000 250 ",
        fill: "none",
        stroke: "#86efac",
        strokeWidth: "3"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "absolute bottom-0 left-0 right-0 flex justify-between text-xs text-slate-300"
    }, Array.from({
        length: 31
    }).map((_, i) => /*#__PURE__*/ React.createElement("span", {
        key: i
    }, `${i + 1}`))));
}
